// partnersData.js
// import tdbLogo from '../assets/images/partners-tbd.png';
import toyotaLogo from '../assets/images/toyotaweb.png';
import yokohamaLogo from '../assets/images/yokohamaweb.png';
import tgrLogo from '../assets/images/tgrweb.png';
import sonyLogo from '../assets/images/sonyweb.png';
import forkastLogo from '../assets/images/forkastweb.png';

export const PARTNERS_DATA = [
  {
    id: "toyota",
    name: "Toyota",
    link: "https://www.toyota.com.py/",
    logo: toyotaLogo,
    showcase: [toyotaLogo],
    description: "Toyota"
  },
  {
    id: "yokohama",
    name: "Yokohama",
    link: "https://yokohama.com.py/",
    logo: yokohamaLogo,
    showcase: [yokohamaLogo],
    description: "Yokohama"
  },
  {
    id: "sony",
    name: "Sony",
    link: "https://www.instagram.com/sonytoyotoshi/",
    logo: sonyLogo,
    showcase: [sonyLogo],
    description: "Sony"
  },
  {
    id: "tgr",
    name: "TGR",
    link: "https://www.instagram.com/toyotagazooracingpy/",
    logo: tgrLogo,
    showcase: [tgrLogo],
    description: "TGR"
  },
  {
    id: "forkast",
    name: "Forkast",
    link: "https://forkast.gg/",
    logo: forkastLogo,
    showcase: [forkastLogo],
    description: "Forkast"
  }
];